module.exports = __webpack_public_path__ + "img/logo-dark_m3.f64816cd.png";